export class tradeLinkDto {

    pdfFileName: string;
}